module.exports = __webpack_public_path__ + "img/xxlj_icon_2.4b5178c5.svg";